/*export const customSelectStyle = {
    control: (provided, { isSelected, isFocused }) => ({
        ...provided,
        borderColor: (isSelected || isFocused) ? '#41C78F' : '#E4E6EF',
        '&:hover': {
            borderColor: '#41C78F'
        }  
    }),
    option: (provided, {isSelected, isFocused}) => ({
        ...provided,
        backgroundColor: (isSelected ? '#41C78F' : (isFocused ? '#E9F8F1' : '#FFF')),
    })
}*/

// Dark: o light tem hex chumbado (#41C78F/#E9F8F1) que não dá pra tokenizar sem mudar o visual,
// então o tema escuro troca a paleta inteira por tokens. Lê o atributo na hora de renderizar
// (os selects ficam em modais, que montam depois do toggle).
const darkColors = {
  primary: "var(--fg-brand-strong)", // opção selecionada (texto = neutral0, escuro)
  primary25: "var(--bg-brand-subtler)",
  primary50: "var(--bg-brand-subtler)",
  neutral0: "var(--bg-neutral-layer02)", // fundo do controle e do menu
  neutral10: "var(--bg-neutral-layer03)",
  neutral20: "var(--border-neutral-strong)",
  neutral30: "var(--border-neutral-strong)",
  neutral40: "var(--fg-neutral-subtle)",
  neutral50: "var(--fg-neutral-subtle)",
  neutral60: "var(--fg-neutral-default)",
  neutral80: "var(--fg-neutral-default)",
};

export const customSelectStyle = theme => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary25: "#E9F8F1",
    primary: "#41C78F",
    ...(document.documentElement.dataset.theme === "dark" && darkColors),
  },
});